export function updateShortDescriptionBox() {
  const loadMoreBtn = document.getElementById('loadMore');
  const browseBox = document.querySelector('.short-description > .browseBox');

  if (loadMoreBtn && browseBox) {
    const p = browseBox.querySelectorAll('.browseBox > *');
    const width = window.innerWidth;

    if ((p.length < 3 && width > 767) || (p.length < 1 && width < 768)) {
      loadMoreBtn.style.display = 'none';
    }

    let isExpanded = false;
    const selector =
      width > 767
        ? '.browseBox > *:nth-child(n+4)'
        : '.browseBox > *:nth-child(n+2)';

    loadMoreBtn.addEventListener('click', () => {
      isExpanded = !isExpanded;

      if (isExpanded) {
        browseBox.querySelectorAll('.browseBox > *').forEach((p) => {
          p.style.display = 'block';
        });
        // loadMoreBtn.textContent = 'hide';
      } else {
        browseBox.querySelectorAll(selector).forEach((p) => {
          p.style.display = 'none';
        });
        // loadMoreBtn.textContent = 'leggi di più';
      }
    });
  }
}
